import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { AuthenticationService } from "./core/services/authentication.api";
import {
  Router,
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  NavigationCancel,
  NavigationError,
} from "@angular/router";
import { filter, map, switchMap, takeUntil } from "rxjs/operators";
import { Title } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { LoggingService } from "./core/services/logging.service";
import { NgxPermissionsService } from "./core/modules/permissions";
import { TranslateConfigService } from "./core/services/translate-config.service";
declare var $: any;
import { CmsManagementService } from "./modules/cms-management/services/cms-management.service";
import { cmsModeTitleCustomizer } from "./shared/components/cms-mode-title-customizer/cms-mode-title-customizer.component";
import { UserService } from "./core/services/user.service";
import * as moment from "moment";
declare var $: any;
import { HttpHandlerService } from "./core/services/http-handler.service";
import { NzI18nService } from "ng-zorro-antd/i18n";
import { enUS } from "date-fns/locale";
import { registerLocaleData } from "@angular/common";
import en from "@angular/common/locales/en";
import { ConfirmModalService } from "./shared/confirm-modal/confirm-modal.service";
import { ComponentBase } from "./core/helpers/component-base.directive";
import { ApplicationLiscenceService } from "./core/services/application-license.service";
import { Subject, Subscription } from "rxjs";
import { ImageDataService } from "./shared/services/imageData/image-data.service";
import { ModelService } from "./shared/components/model/model.service";
import { Mode, Size } from "./shared/components/model/enum";
import { TitlePageService } from "./core/services/titlePage.service";
import { PageLoadingService } from "./shared/services/page-loading/page-loading.service";

declare var $: any;

declare var $: any;
registerLocaleData(en);

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent
  extends ComponentBase
  implements OnInit, OnDestroy, AfterViewInit
{
  private endSub$ = new Subject();
  title = "EppmPortal";
  sidebarCounter = {
    citizens: 0,
    applications: 0,
    suppliers: 0,
  };
  confirmMsg: string = null;
  remainingDays: number = 0;
  lang: string = this.translate.currentLang;
  selectedValueForTranslation: string = "";
  selectedTranslationObj: any;

  @ViewChild("cmsModeTitleCustomizer")
  cmsModeTitleCustomizer: cmsModeTitleCustomizer;

  status!: string;
  subscription = new Subscription();
  // modal vars
  modeEnum = Mode;
  sizeEnum = Size;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: TitlePageService,
    private translateModule: TranslateService,
    private userService: UserService,
    private permissionsService: NgxPermissionsService,
    private loggingSrvc: LoggingService,
    private translateConfigService: TranslateConfigService,
    private confirmationPopupService: ConfirmModalService,
    private applicationLiscenceService: ApplicationLiscenceService,
    private cmsManagementService: CmsManagementService,
    private imageDataService: ImageDataService,
    private modalService: ModelService,
    private i18n: NzI18nService,
    private http: HttpHandlerService,
    private loadingService: PageLoadingService
  ) {
    super(translateConfigService, translateModule);
    // router.events.forEach(event => {
    //   if (event instanceof NavigationStart) {
    //     if (!event.url?.includes("login")) {
    //       localStorage.setItem("latestLocation", event.url);
    //     }
    //     $(".modal-backdrop").remove();
    //   }
    //   switch (true) {
    //     case event instanceof NavigationStart: {
    //       console.log("hellllo");

    //       loadingService.show();
    //       break;
    //     }
    //     case event instanceof NavigationEnd:
    //     case event instanceof NavigationCancel:
    //     case event instanceof NavigationError: {
    //       setTimeout(() => {
    //         loadingService.hide();
    //       }, 500);
    //       break;
    //     }
    //     default: {
    //       break;
    //     }
    //   }
    // });
  }

  ngOnInit(): void {
    this.translateConfigService.getSystemLang();
    this.titleService.init();
    // this.http.post("/Utilities/api/CMS/Resource/SetDocument?module=51&isArabic=true", arabic).subscribe((res) => {
    //   console.log(res);

    // })
    // this.http.post("/Utilities/api/CMS/Resource/SetDocument?module=51&isArabic=false", english).subscribe((res) => {
    //   console.log(res);

    // })

    this.i18n.setDateLocale(enUS);
    let formattedTokenExpiryDate = this.userService
      .getToken()
      ?.expires?.replace(/\\/g, "");
    if (formattedTokenExpiryDate) {
      const tokenExpiryDate = new Date(formattedTokenExpiryDate);
      if (moment(tokenExpiryDate).isBefore()) {
        // this.userService.clear();
        // this.userService.getRefreshToken()
      }
    }
    // this.subscription.add(
    //   this.NetworkErrorConnectionService.checkConnection().subscribe(),
    // );

    // this.translationService.init(environment.defaultLang);
    const onNavigationEnd = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    );
    // Change page title on navigation or language change, based on route data
    onNavigationEnd
      .pipe(
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route: any) => route.outlet === "primary"),
        switchMap((route: any) => route.data)
      )
      .subscribe((event: any) => {
        // close image preview if still opened
        this.previewingImage && this.closePreview();

        // this.translateModule.onLangChange.subscribe(lang => {
        //   this.titleService.setTitle(
        //     this.translateModule.instant(event.title || environment.appName)
        //   );
        // })
      });
    const claims = localStorage.getItem(`$EPPM$claims`);
    if (!!claims) {
      this.permissionsService.loadPermissions(JSON.parse(claims));
    }
    this.handleLanguage();
    this.applicationLiscenceService
      .checkLicenseStatus()
      .pipe(takeUntil(this.endSub$))
      .subscribe(res => {
        // check if warning text
        if (res) {
          if (res.status.toLocaleLowerCase() == "warning".toLocaleLowerCase()) {
            this.remainingDays = res.remainingDays;
            this.confirmMsg =
              this.lang == "en"
                ? `Dear, <br/> Kindly be aware that your application license is set to expire in ${this.remainingDays} days. We encourage you to reach out to our support team to ensure a seamless license renewal process and prevent any interruptions.`
                : `عزيزي/عزيزتى <br/>
                نود أن نلفت انتباهك إلى أن ترخيص التطبيق الخاص بك سينتهي خلال ${this.remainingDays} يومًا
                نشجعك على التواصل مع فريق الدعم لضمان عملية تجديد الترخيص بسلاسة وتجنب أي انقطاعات
                مع خالص التحية،`;

            this.openWarningConfirmationPopup();
          }
        }
      });
  }

  ngAfterViewInit(): void {
    this.cmsManagementService.selectedTranslationObj.subscribe(res => {
      if (res !== null) {
        this.selectedTranslationObj = res;
        this.selectedValueForTranslation =
          res.selectedValueForTranslation[this.translate.currentLang];
        this.cmsModeTitleCustomizer.cmsModeForm.patchValue({
          titleEn: this.selectedTranslationObj?.selectedValueForTranslation?.en,
          titleAr: this.selectedTranslationObj?.selectedValueForTranslation?.ar,
        });
      }
    });
    // listen when open an image preview
    this.imageDataService.imageData
      .pipe(takeUntil(this.endSub$))
      .subscribe((imageSrc: string) => {
        this.selectedImageSrc = imageSrc;
        this.previewingImage = true;
      });
  }

  handleLanguage() {
    this.translateModule.onLangChange
      .pipe(takeUntil(this.endSub$))
      .subscribe(result => {
        this.lang = result.lang;
        this.confirmMsg =
          this.lang == "en"
            ? `Dear, <br/> Kindly be aware that your application license is set to expire in ${this.remainingDays} days. We encourage you to reach out to our support team to ensure a seamless license renewal process and prevent any interruptions.`
            : `عزيزي/عزيزتى <br/>
        نود أن نلفت انتباهك إلى أن ترخيص التطبيق الخاص بك سينتهي خلال ${this.remainingDays} يومًا
        نشجعك على التواصل مع فريق الدعم لضمان عملية تجديد الترخيص بسلاسة وتجنب أي انقطاعات
        مع خالص التحية،`;
      });
  }

  openWarningConfirmationPopup() {
    this.confirmationPopupService.open("warning-license");
  }

  public onConfirmed() {
    this.confirmationPopupService.close("warning-license");
  }

  selectedImageSrc: string = null;
  previewingImage: boolean = false;

  closePreview() {
    this.modalService.close();
    this.previewingImage = false;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.endSub$.next(null);
    this.endSub$.complete();
  }
}
